export const SESSION_EXPIRE = "SESSION_EXPIRE";
export const IS_AUTH = "IS_AUTH";
export const AUTH_STATUS = "AUTH_STATUS";
export const IS_EMAIL_VERIFY = "IS_EMAIL_VERIFY";
export const UPLOAD_RESUME_AUTH = "UPLOAD_RESUME_AUTH";
export const IS_UPLOAD_EMAIL_VERIFY = "IS_UPLOAD_EMAIL_VERIFY";
export const SWITCH_ACCOUNT = "SWITCH_ACCOUNT";
export const IS_UPD_RESUME_AUTH = "IS_UPD_RESUME_AUTH";
export const EMAIL_CONFIRMATION_DETAIL = "EMAIL_CONFIRMATION_DETAIL";
